import { render, staticRenderFns } from "./ApprendoTable.vue?vue&type=template&id=2dfa8548&scoped=true"
import script from "./ApprendoTable.vue?vue&type=script&lang=js"
export * from "./ApprendoTable.vue?vue&type=script&lang=js"
import style0 from "./ApprendoTable.vue?vue&type=style&index=0&id=2dfa8548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dfa8548",
  null
  
)

export default component.exports